import posthog from 'posthog-js';

const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com';

export const initPostHog = () => {
  if (!KEY) return;
  posthog.init(KEY, {
    api_host: HOST,
    ui_host: 'https://us.posthog.com',
    capture_pageview: false,   // handled via router
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true,
    },
    persistence: 'localStorage+cookie',
    loaded(ph) {
      if (import.meta.env.DEV) ph.debug();
    },
  });
};

export const identifyUser = (id: string, traits?: Record<string, unknown>) => {
  if (!KEY) return;
  posthog.identify(id, traits);
};

export const resetIdentity = () => {
  if (!KEY) return;
  posthog.reset();
};

export const trackEvent = (event: string, props?: Record<string, unknown>) => {
  if (!KEY) return;
  posthog.capture(event, props);
};

export const trackPageView = () => {
  if (!KEY) return;
  posthog.capture('$pageview');
};

export default posthog;
